import { ICart, IEmptyCart } from '@/src/modules/cart/ICart'

interface IUpdateData {
    cartData: ICart | IEmptyCart
    existingPlasticDeliveryIndex: number
    editingLineItemUuid: string
    lineItem: any
}

function updateExistingDeliveryData({
    cartData,
    existingPlasticDeliveryIndex,
    editingLineItemUuid,
    lineItem,
}: IUpdateData) {
    // get the existing item by plastic uuid
    const itemIndex: number = cartData?.cart_contents?.deliveries[
        existingPlasticDeliveryIndex
    ].line_items.findIndex((item) => {
        return item.line_item_uuid === editingLineItemUuid
    })

    // update ONLY the edited plastic line item in the plastic delivery array
    cartData.cart_contents.deliveries[existingPlasticDeliveryIndex].line_items[
        itemIndex
    ] = lineItem
}

export default updateExistingDeliveryData
